import { render, staticRenderFns } from "./BesondereAusstattung.vue?vue&type=template&id=3985d1c4"
import script from "./BesondereAusstattung.vue?vue&type=script&lang=js"
export * from "./BesondereAusstattung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports